// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1HYrJ","search":"Settings_search__2qedW","filter":"Settings_filter__1ROx_"};